import { createGlobalStyle } from 'styled-components';
import { COLOR, SIZE } from './constants.js';

const Root = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
    }
    html {
        height: 100%;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    body {
        height: 100%;
        width: 100%;
        margin: 0;
        padding: 0;
        background: ${COLOR.background};
    }


    // ******  BUTTONS  ******

    .btn, .btn-large {
        text-transform: none;
    }
    .modal.open {
        .modal-footer {
            .btn {
                margin: 0 8px;
            }
        }
    }


    // ******  INPUTS  ******

    // To change select options text color
    ul.dropdown-content.select-dropdown li span {
        color: ${COLOR.black}; /* no need for !important :) */
    }

    .input-field.col {
        width: 100%;
        margin: 0 0;
        padding: 0 0;
        > label.active,
        // date/time inputs always float their label via these type-selectors,
        // never getting the .active class, so they need the same override.
        > input[type=date]:not(.browser-default) + label,
        > input[type=time]:not(.browser-default) + label,
        // react-materialize's TimePicker renders type="text" (M.Timepicker sets
        // the value imperatively, bypassing React, so .active is never added)
        // but always tags the input with class="timepicker", so match on that.
        > input.timepicker:not(.browser-default) + label,
        // Same story for react-materialize's DatePicker: type="text",
        // class="datepicker", value set imperatively by M.Datepicker.
        > input.datepicker:not(.browser-default) + label,
        // Chrome autofill (e.g. saved names/addresses) floats the label via
        // materialize's own :-webkit-autofill selector, bypassing .active too;
        // matched here with the same specificity shape so this wins instead.
        > input[type]:-webkit-autofill:not(.browser-default):not([type="search"]) + label {
            font-size: 16px;
            transform: translateY(-26px) scale(1);
            transform-origin: 0 0;
            color: ${COLOR.ferra};
        }
        > input, textarea, .select-wrapper > input {
            font-family: 'Monaco';
            font-size: 14px;
            border: 2px solid ${COLOR.ferra};
            padding: 0 16px;
            background: none;
            // Avoid width overflow
            width: 100%;
            // Flex items default to min-width: auto, so their intrinsic content
            // width (e.g. iOS Safari's native input[type=date] control, which is
            // wider there than on Android/desktop) can override width: 100% and
            // overflow the flex container.
            min-width: 0;
            -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
            -moz-box-sizing: border-box;    /* Firefox, other Gecko */
            box-sizing: border-box;  
            //
            float: none;
            display: block;
            border-radius: ${SIZE.inp_radious};
            transition: box-shadow, border-color 0.25s;
            &:focus:not([readonly]) {
                border-color: ${COLOR.ferra};
                box-shadow: 0 1px 0 0 ${COLOR.ferra}; //0 2px 0 0, for border 2px solid
            }
            &:focus:not([readonly]) + label {
                color: ${COLOR.ferra} !important;
            }
            :focus, input:focus {
                color: ${COLOR.ferra};
            }
            ::placeholder {
                color: ${COLOR.gray};
                opacity: 1; /* Firefox */
            }
            ::-ms-input-placeholder { /* Edge 12 -18 */
                color: ${COLOR.gray};
            }
        }
        .materialize-textarea {
            padding: 16px;
            height: 200px;
        }
    }

    // Selects rendered with noLayout (e.g. bodyeventbooking) skip the .col
    // class above, so the bordered look is re-applied here without needing it,
    // keeping the native dropdown chevron untouched.
    .input-field .select-wrapper > input.select-dropdown {
        font-family: 'Monaco';
        font-size: 14px;
        border: 2px solid ${COLOR.ferra};
        padding: 0 16px;
        background: none;
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: ${SIZE.inp_radious};
        transition: box-shadow, border-color 0.25s;
        &:focus:not([readonly]) {
            border-color: ${COLOR.ferra};
            box-shadow: 0 1px 0 0 ${COLOR.ferra};
        }
    }


    // ******  DATE PICKER  ******
    .datepicker-date-display {
        background-color: ${COLOR.primaryDark}
    }
    .datepicker-day-button:focus {
        color: white !important;
        background-color: ${COLOR.primaryClear}
    }
    .datepicker-done,
    .datepicker-cancel,
    .select-dropdown li>span,
    .datepicker-row {
        .is-today {
            color: ${COLOR.gold} !important
        }
    }
    .btn-flat.datepicker-cancel.waves-effect, .btn-flat.datepicker-done.waves-effect {
        color: ${COLOR.gold} !important
    }
    td.is-selected,
    .month-prev:active,
    .month-prev:focus,
    .month-next:active,
    .month-next:focus {
        background-color: ${COLOR.primaryDark} !important
    }
    td.is-selected.is-today {
        color: white !important
    }

`;

export {
    Root
}